import React, { Component } from "react";
import Grid from "@mui/material/Grid";
import { Breadcrumbs, Typography } from "@mui/material";
import Link from "@mui/material/Link";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import CtBtn from "../Components/CustomTool/CtBtn";
import CtDtp from "./CustomTool/CtDtp";
import CtMultiLineText from "../Components/CustomTool/CtMultiLineText";
import CtCmbEditable from "../Components/CustomTool/CtCmbEditable";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { withRouter } from "../HOC/withRouter";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { get_YMD_from_SYS } from "../SystemUtility/SystemUtility";

class AMCBlock extends Component {
  state = {
    formData: {
      dtpBlockDate: get_YMD_from_SYS(new Date()),
      cmbBlockBy: "",
      txtRemark: "",
    },
    blockByList: [{ name: "Customer" }, { name: "Management" }],
  };

  componentDidMount() {
    document.title = "AMC Block";
    localStorage.setItem("Heading", "AMC Block");
    this.props.verifyUserID(this.getInfo, this.props.setUserPrivileges);
  }

  getInfo = () => {
    document.getElementById("dtpBlockDate")?.focus();
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  blockAMC = () => {
    const { dtpBlockDate, cmbBlockBy } = this.state.formData;
    if (!dtpBlockDate) {
      this.props.toastErrorMsg("Select Block Date", "dtpBlockDate");
      return;
    }
    if (!cmbBlockBy) {
      this.props.toastErrorMsg("Select Block By", "cmbBlockBy");
      return;
    }
    this.props.toastMsg("success", "AMC Blocked Successfully");
    this.clearInfo();
  };
  clearInfo = () => {
    this.setState({
      formData: {
        ...this.state.formData,
        // dtpBlockDate: "",
        cmbBlockBy: "",
        txtRemark: "",
      },
    });
  };

  render() {
    const { formData } = this.state;
    return (
      <form>
        {/* <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="#/Dashboard">
            Dashboard
          </Link>
          <Link underline="hover" color="inherit" href="#/AMCDashboard">
            AMC Dashboard
          </Link>
          <Typography sx={{ color: "text.primary" }}>Block AMC</Typography>
        </Breadcrumbs> */}

        <Grid container spacing={2} marginTop={2}>
          <Grid item>
            <CtDtp
              id="dtpBlockDate"
              label="Date*"
              value={formData.dtpBlockDate}
              handleOnChange={this.handleOnChange}
              width={180}
              onKeyDown={this.props.onKeyDown}
              maxLength={100}
              nextCtrlID={"cmbBlockBy"}
            />
          </Grid>
          <Grid item>
            <CtCmbEditable
              id="cmbBlockBy"
              label="Block By*"
              items={this.state.blockByList}
              colID="name"
              value={formData.cmbBlockBy}
              handleOnChange={this.handleOnChange}
              width={220}
              maxLength={100}
              nextCtrlID={"txtRemark"}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>
          <Grid item>
            <CtMultiLineText
              id="txtRemark"
              label="Remark"
              value={formData.txtRemark}
              handleOnChange={this.handleOnChange}
              width={520}
              maxLength={1000}
              onKeyDown={this.props.onKeyDown}
            />
          </Grid>
          <Grid item>
            <CtBtn
              label="Block"
              className="delete-button"
              onClick={this.blockAMC}
            />
          </Grid>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  const navigate = useNavigate();
  return <AMCBlock {...props} navigate={navigate} />;
}

export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
